import { HttpClient } from '@angular/common/http';
import { Component, Input, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { SseService } from 'src/app/services/SseService';


@Component({
  selector: 'app-presentaciones',
  templateUrl: './presentaciones.component.html',
  styleUrl: './presentaciones.component.scss'
})
export class PresentacionesComponent implements OnChanges {

  @Input() compania: string = '';
  dataSource = new MatTableDataSource();
  @ViewChild(CdkVirtualScrollViewport)
  viewport: CdkVirtualScrollViewport;
  public selectedFilter = 'quarter';
  public iso='';

  constructor(private _sseService: SseService) {

  }
  displayedColumns: string[] = ['finalLink', 'period', 'fillingDate','date'];

  ngOnChanges(changes: SimpleChanges) {

    this.iso=changes['compania'].currentValue;
    console.log('Cambio en presentaciones:', this.iso);
    if(this.iso){
      this.cargarData();
    }

  }

  cargarData() {
    let url='';

    if (this.selectedFilter === 'quarter') {
       url = 'v3/income-statement/' + this.iso + '?period=quarter'

    } else if (this.selectedFilter === 'year') {
       url = 'v3/income-statement/' + this.iso + '?period=annual'
    }
    console.log("desde reperesentasionc: ",url);
    this._sseService.apiGetNew(url).subscribe({
      next: (data: any)=>{
        this.dataSource.data = data;
      }
    });
}

  applyFilter(event: Event) {

    const filterValue = (event.target as HTMLInputElement).value;
    console.log("llega evento", filterValue);
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

 // no esta en uso el filtro personalizado por ahora
  customFilterPredicate(data: any, filter: string): boolean {
    const fieldValue = (data.nombre || '').toLowerCase();
    //data.nombre indica que filtrara por el campo nombre
    // Comprueba si el valor del campo contiene el filtro proporcionado
    return fieldValue.includes(filter);
  }

  applyFilterCustom(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value.trim().toLowerCase();
    console.log("llega evento", filterValue);
    this.dataSource.filterPredicate = (data, filter) => this.customFilterPredicate(data, filter);
    this.dataSource.filter = filterValue;
  }


}
